import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import * as React from 'react';

const NotificationComponent = ({ isOpen, message, onClose, severity }) => {
    const [open, setOpen] = React.useState(isOpen);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        if (onClose) onClose(false);  // Callback to update parent state
    };

    React.useEffect(() => {
        setOpen(isOpen); // When the `isOpen` prop changes, update the local state
    }, [isOpen]);

    // severity = success, info, warning, error
    // variant = notPassed, filled, outlined
    return (
        <Snackbar open={open} autoHideDuration={4 * 1000} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
            <Alert
                onClose={handleClose}
                severity={severity}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
}

export default NotificationComponent;
